import { CheckCircle2, History, XCircle } from "lucide-react";

import { EmptyState } from "@/components/common/empty-state";
import { formatDateTime } from "@/lib/format";
import type { SessionAction } from "@/types/admin";

export function SessionActivityCard({ activity }: { activity: SessionAction[] }) {
  return (
    <section className="card-surface flex flex-col">
      <header className="border-b border-border px-5 py-4">
        <h2 className="font-display text-base font-semibold">Session activity</h2>
        <p className="mt-0.5 text-xs text-muted-foreground">
          Decisions you made since signing in. Not stored on the server.
        </p>
      </header>

      {activity.length === 0 ? (
        <EmptyState
          icon={History}
          title="No decisions yet"
          description="Approvals and rejections you make will be listed here for this session."
          className="py-10"
        />
      ) : (
        <ul className="divide-y divide-border">
          {activity.map((item) => (
            <li key={item.id} className="flex items-start gap-3 px-5 py-3.5">
              {item.kind === "approved" ? (
                <CheckCircle2 className="mt-0.5 size-4 shrink-0 text-success" aria-hidden="true" />
              ) : (
                <XCircle className="mt-0.5 size-4 shrink-0 text-destructive" aria-hidden="true" />
              )}
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-medium">{item.doctorName}</p>
                <p className="truncate text-xs text-muted-foreground">
                  {item.specialization} · {item.kind} · {formatDateTime(item.at)}
                </p>
                {item.reason && (
                  <p className="mt-1 text-xs text-muted-foreground italic">“{item.reason}”</p>
                )}
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
